<template>
    <div class="container">
        <van-nav-bar  title="振动盘打铁助手" left-text=""  />
        <div class="migrate-guide">
            <div class="guide-title">小程序版已上线</div>
            <div class="guide-sub">H5 版功能已迁移至小程序<br>请使用微信扫码，直接进入小程序</div>
            <img class="guide-qr" src="/mp-qrcode.jpg" />
            <div class="guide-tip">微信「扫一扫」或长按识别小程序码<br>你的项目数据已同步，登录即可看到</div>
        </div>
        <div class="contactUsBnt" id="contactUsBnt" >
      <div style="font-size: 1.2rem;color: #439ae5;display:none;"> 更多功能开发中，即将发布</div>
      <van-button  @click="showContactUsBox" style="border: none;">需要帮助？ 请点击这里</van-button>
      <div class="icp"><a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2023049187号-1</a></div>
      </div>
      <van-dialog v-model="showContactUs" class="contactUsBox" title="扫一扫，加我微信" >
          <van-image
            width="240"
            height="240"
            src="/contact.jpg" ></van-image>
     </van-dialog>
    </div>


</template>
<script>

import Vue from 'vue'
import { Col, Row, Slider, Stepper, Image as VanImage, Button,Toast,Swipe, SwipeItem,Checkbox, CheckboxGroup,Popup ,Field,RadioGroup, Radio } from 'vant'
Vue.use(Col)
Vue.use(Slider)
Vue.use(Row)
Vue.use(Stepper)
Vue.use(Button)
Vue.use(VanImage)
Vue.use(Swipe);
Vue.use(SwipeItem)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Popup)
Vue.use(Field)
Vue.use(Radio)
Vue.use(RadioGroup)
export default {
    data() {
        return {
            showContactUs: false
        }
    },
    methods: {
        showContactUsBox() {
        //let box = new LoginBox()
            this.showContactUs = true
        }
    },
    
    mounted () {

       
    }
}
</script>
<style scoped>
   #head {
     font-size: 1.2rem;
    color: #1ca4f3;
    height: 120px;
    line-height: 120px;
   }
   .choose {
       font-size: 1.5rem;
       margin-top: 20px;
   }
.contactUsBnt {
   text-align: center;
   text-align: center;
   position: fixed;
   width: 100%;
   bottom: 60px;
}
.contactUsBox /deep/.van-dialog__content {
    display: flex;
    justify-content: center;
  }
  .container {
    text-align: center;
  }
  .migrate-guide {
    margin-top: 40px;
    padding: 0 24px;
  }
  .guide-title {
    font-size: 1.4rem;
    font-weight: bold;
    color: #323233;
  }
  .guide-sub {
    margin-top: 12px;
    font-size: 0.95rem;
    color: #646566;
    line-height: 1.8;
  }
  .guide-qr {
    width: 220px;
    height: 220px;
    margin-top: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  }
  .guide-tip {
    margin-top: 16px;
    font-size: 0.8rem;
    color: #969799;
    line-height: 1.8;
  }
  .icp a, a:visited{
     color: #333;
     font-size: 0.75rem;
  }
</style>